import { render, staticRenderFns } from "./GameboardQuiz.vue?vue&type=template&id=11666cb4&"
import script from "./GameboardQuiz.vue?vue&type=script&lang=js&"
export * from "./GameboardQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports